var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.2126C0 1.57126 0.225232 1.04215 0.675676 0.625301C1.12612 0.208427 1.71172 0 2.43243 0C3.14029 0 3.71299 0.205214 4.15058 0.615681C4.60102 1.03896 4.82625 1.5905 4.82625 2.27032C4.82625 2.886 4.60747 3.39906 4.16988 3.80952C3.71944 4.2328 3.12741 4.44444 2.39382 4.44444H2.37452C1.66666 4.44444 1.09396 4.2328 0.656371 3.80952C0.218784 3.38624 0 2.85393 0 2.2126ZM0.250965 19.0476V6.19529H4.53668V19.0476H0.250965ZM6.9112 19.0476H11.1969V11.8711C11.1969 11.4221 11.2484 11.0758 11.3514 10.8321C11.5315 10.396 11.805 10.0272 12.1718 9.72583C12.5386 9.4244 12.9987 9.27369 13.5521 9.27369C14.9936 9.27369 15.7143 10.2421 15.7143 12.1789V19.0476H20V11.6787C20 9.78034 19.5496 8.34055 18.6486 7.35931C17.7477 6.37807 16.5573 5.88745 15.0772 5.88745C13.417 5.88745 12.1236 6.59933 11.1969 8.02309V8.06157H11.1776L11.1969 8.02309V6.19529H6.9112C6.93693 6.60573 6.94981 7.88198 6.94981 10.0241C6.94981 12.1661 6.93693 15.1739 6.9112 19.0476Z",
    fill: "#454551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinImg);
export default __webpack_public_path__ + "static/media/linkedin-img.971de53348168519fac11268864c0e84.svg";
export { ForwardRef as ReactComponent };